var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecurityWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3854_74013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0586 6.42962C22.0463 5.78166 22.0345 5.16953 22.0345 4.57734C22.0345 4.11341 21.6585 3.73728 21.1945 3.73728C17.6018 3.73728 14.8665 2.70479 12.5864 0.487924C12.2603 0.170717 11.7412 0.170829 11.4152 0.487924C9.13535 2.70479 6.40045 3.73728 2.80801 3.73728C2.34407 3.73728 1.96794 4.11341 1.96794 4.57734C1.96794 5.16964 1.9563 5.78199 1.94386 6.43007C1.82872 12.4601 1.67101 20.7186 11.7257 24.2038C11.8148 24.2347 11.9078 24.2501 12.0007 24.2501C12.0937 24.2501 12.1868 24.2347 12.2758 24.2038C22.3313 20.7185 22.1738 12.4598 22.0586 6.42962ZM12.0009 22.5186C3.37768 19.3861 3.50806 12.5239 3.62376 6.46211C3.63071 6.0983 3.63743 5.7457 3.64213 5.40004C7.00686 5.25802 9.69752 4.23841 12.0009 2.23189C14.3044 4.23841 16.9955 5.25813 20.3605 5.40004C20.3652 5.74559 20.3719 6.09797 20.3788 6.46155C20.4944 12.5235 20.6247 19.386 12.0009 22.5186Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8946 9.33187L10.84 13.3862L9.10979 11.656C8.78172 11.3281 8.2498 11.3281 7.92184 11.656C7.59376 11.9842 7.59376 12.516 7.92184 12.8441L10.246 15.1683C10.41 15.3323 10.625 15.4143 10.84 15.4143C11.0549 15.4143 11.27 15.3323 11.434 15.1683L16.0824 10.5199C16.4106 10.1919 16.4106 9.65995 16.0825 9.33199C15.7546 9.00391 15.2226 9.0038 14.8946 9.33187Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3854_74013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityWhite);
export default __webpack_public_path__ + "static/media/securityWhite.7861503fac31c8154183d308238f40eb.svg";
export { ForwardRef as ReactComponent };